<template>
  <div id="statistical-data">
    <div class="statisticalData-title">{{$t("statistical")}}</div>
    <div class="statisticalData-content">
      <dv-border-box-12>
        <div v-if="minuteShow" class="statistical-loading1">
          <dv-loading>Loading...</dv-loading>
        </div>
        <div class="statistical-minute">
          <div class="statistical-minute-btn">
            <el-button round @click="fiveMinute" :disabled="minuteShow">{{$t("five")}}</el-button>
            <el-button round @click="tenMinute":disabled="minuteShow">{{$t("ten")}}</el-button>
            <el-button round @click="oneHour" :disabled="minuteShow">{{$t("hour")}}</el-button>
            <el-date-picker @change="selectTime" v-model="timeValue" type="datetimerange" :picker-options="pickerOptions" :clearable="false"
                            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right" :disabled="minuteShow"></el-date-picker>
            <el-button style="margin-top: 0.5%; margin-left: -3%" round @click="onSearch" :disabled="minuteShow">查询</el-button>
          </div>
          <div id="minute" class="statistical-minute-option"></div>
          <div class="statistical-minute-sum" >
            <el-button @click="minuteExport()" round :disabled="minuteShow">{{$t("export")}}</el-button>
            <el-tag>{{$t("sum")}}：{{minuteSum}}mm</el-tag>
          </div>
        </div>
        <dv-decoration-2 class="statistical-dv2"/>
        <div v-if="dayShow" class="statistical-loading2">
          <dv-loading>Loading...</dv-loading>
        </div>
        <div class="statistical-day" style=" width: 100%;height: 48.5%;display: flex;flex-direction: column;">
          <div class="statistical-day-btn">
            <el-button round @click="dayData()" :disabled="dayShow">1月内雨量</el-button>
<!--            <el-button round @click="dayData()" :disabled="dayShow">{{$t("day")}}</el-button>-->
<!--            <el-button round @click="monthData()" :disabled="dayShow">{{$t("month")}}</el-button>-->
          </div>
          <div id="day" class="statistical-day-option"></div>

          <div class="statistical-day-exp">
            <div class="statistical-exp-title">
              <div style="background-color: red;" class="statistical-exp-con"></div>
              暴雨
            </div>
            <div class="statistical-exp-title">
              <div style="background-color: orange;" class="statistical-exp-con"></div>
              大雨
            </div>
            <div class="statistical-exp-title">
              <div style="background-color: yellow;" class="statistical-exp-con"></div>
              中雨
            </div>
            <div class="statistical-exp-title">
              <div style="background-color: blue;" class="statistical-exp-con"></div>
              小雨
            </div>
          </div>
          <div class="statistical-day-sum" >
            <el-button round  @click="DayExport()" :disabled="dayShow">{{$t("export")}}</el-button>
            <el-tag>{{$t("sum")}}：{{daySum}}mm</el-tag>
          </div>
        </div>
      </dv-border-box-12>
    </div>
  </div>
</template>

<script>
  import moment from "moment"
  import {getTimeDeviceHistory} from "../untils/api/home";
  export default {
    name: 'StatisticalData',
    data() {
      return {
        deviceInfo: {},
        key: '',
        minuteTime: [],
        minuteValue: [],
        exportMinute: [],
        minuteName: '',
        //minuteNum: 0,
        minuteShow: false,
        minuteSum: '',
        dayTime:[],
        dayValue:[],
        exportDay: [],
        dayName: '',
        dayShow: false,
        daySum: '',
        pickerOptions: {
          shortcuts: [{
            text: '最近一小时',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 1);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三小时',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 3);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近五小时',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 5);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        timeValue:  [moment().format("YYYY-MM-DD HH:mm"), moment().subtract(-1, "days").format("YYYY-MM-DD HH:mm")],
        startTime: '',
        endTime: ''
      }
    },

    methods: {
      /**
       * 初期化数据清空
       * @param response
       */
      iniHistory(deviceInfo, key) {
        this.deviceInfo = deviceInfo;
        this.key = key;
        this.minuteTime = [];
        this.minuteValue = [];
        this.exportMinute = [];
        this.minuteName = '';
        //this.minuteNum = 0;
        this.minuteShow = false;
        this.minuteSum = '';
        this.dayTime = [];
        this.dayValue = [];
        this.exportDay = [];
        this.dayName = '';
        this.dayShow = false;
        this.daySum = '';
        this.setMinuteEmpty();
        this.setDayEmpty();

      },
      /**
       * 初期化五分钟柱状图
       * @param response
       */
      iniMinuteHistory(){
        this.fiveMinute();
      },

      /**
       * 五分钟雨量
       */
      fiveMinute(){
        let startTime = new Date(moment().subtract(2, "hours")).getTime();
        let endTime = new Date(moment()).getTime();
        let interval = 1000 * 60  * 5;
        this.minuteName = this.$t("fiveMinuteRainfall");
        this.setMinuteEmpty();
        this.minuteHistory(startTime, endTime, interval, 0);
      },

      /**
       * 十分钟雨量
       */
      tenMinute(){
        let startTime = new Date(moment().subtract(5,"hours")).getTime();
        let endTime = new Date(moment()).getTime();
        let interval = 1000 * 60 * 10;
        this.minuteName = this.$t("tenMinuteRainfall");
        this.setMinuteEmpty();
        this.minuteHistory(startTime, endTime, interval, 1);
      },

      oneHour() {
        let startTime = new Date(moment().subtract(1,"days")).getTime();
        let endTime = new Date(moment()).getTime();
        let interval = 1000 * 60 * 60;
        this.minuteName = this.$t("oneHourRainfall");
        this.setMinuteEmpty();
        this.minuteHistory(startTime, endTime, interval, 2)
      },

      selectTime(val) {
        if (val === null) {
          this.timeValue = [moment().format("YYYY-MM-DD HH:mm"), moment().subtract(-1, "days").format("YYYY-MM-DD HH:mm")];
        } else {
          this.startTime = new Date(val[0]).getTime();
          this.endTime = new Date(val[1]).getTime();
        }
      },

      onSearch() {
        if(this.startTime != '' && this.endTime != '') {
          this.minuteName = "时段雨量";
          this.setMinuteEmpty();
          this.setInterval();
        }
      },

      setInterval() {
        let interval = 0;
        let agg = 'NONE';
        if(this.endTime - this.startTime <= 1000 * 60 * 60 * 24) {
          interval = 0;
          agg = 'NONE';
        } else {
          agg = 'MAX';
          let intervalTime = (this.endTime - this.startTime) / (1000 * 60 * 60 * 24);
          switch (true) {
            case intervalTime > 1 && intervalTime <= 3://大于1天小于等于3天
              interval = 1000 * 60 * 10;
              break;
            case intervalTime > 3 && intervalTime <= 5: //大于3天小于等于5天
              interval = 1000 * 60 * 15;
              break;
            case intervalTime > 5 && intervalTime <= 10: //大于5天小于等于10天
              interval = 1000 * 60 * 30;
              break;
            case intervalTime > 10 && intervalTime <= 20: //大于10天小于等于20天
              interval = 1000 * 60 * 60;
              break;
            case intervalTime > 20 && intervalTime <= 30: //大于20天小于等于30天
              interval = 1000 * 60 * 60 * 2;
              break;
            case intervalTime > 30 && intervalTime <= 90://大于1个月小于3个月
              interval = 1000 * 60 * 60 * 5;
              break;
            case intervalTime > 90 && intervalTime <= 180://大于3个月小于6个月
              interval = 1000 * 60 * 60 * 10;
              break;
            case intervalTime > 180 && intervalTime <= 240://大于6个月小于9个月
              interval = 1000 * 60 * 60 * 12;
              break;
            case intervalTime > 240://大于8个月
              interval = 1000 * 60 * 60 * 24;
              break;
          }
        }
        this.selectTimeHistory(interval, agg);
      },
      // onSearch() {
      //
      // },

      /**
       * 访问api获取历史雨量
       * @param startTime
       * @param endTime
       */
      minuteHistory(startTime, endTime, interval, ban){
        this.minuteTime = [];
        this.minuteValue = [];
        this.exportMinute = [];
        //this.minuteNum++;
        this.minuteSum = '';
        this.minuteShow = true;
        getTimeDeviceHistory(this.deviceInfo.entityType, this.deviceInfo.id, this.key, startTime, endTime, interval, 'MAX').then(response => {
          this.minuteShow = false;
          //this.minuteNum = 0;
          for(let obj in response){
            let sum = 0;
            for(let i = response[obj].length - 1; i > 0; i--){
              let num;
              if(parseFloat(response[obj][i].value) - parseFloat(response[obj][i - 1].value) < 0){
                num = parseFloat(parseFloat(response[obj][i].value).toFixed(2));
                sum += num;
              } else {
                num = parseFloat((parseFloat(response[obj][i].value) - parseFloat(response[obj][i - 1].value)).toFixed(2));
                sum += num;
              }
              this.minuteTime.push(this.dateFormat(response[obj][i].ts).substring(5));
              this.minuteValue.push(num);
              this.exportMinute.push({
                ts: this.dateFormat(response[obj][i].ts),
                value: num
              })
            }
            this.minuteSum = sum.toFixed(2);
          }
          if(this.minuteTime.length !== 0){
            this.setMinuteOption();
          }
        }).catch(error => {
          // if(this.minuteNum > 4){
          //   this.minuteNum = 0;
          //   this.minuteShow = false;
          //   console.log("error",error);
          // } else {
          //   if(ban == 0) {
          //     this.fiveMinute();
          //   }else if(ban == 1){
          //     this.tenMinute();
          //   } else {
          //     this.oneHour();
          //   }
          //   //ban === 0 ? this.fiveMinute() : this.tenMinute();
          // }

          this.minuteShow = false;
          this.setMinuteEmpty();
          console.log("error", error);
        })
      },

      selectTimeHistory(interval, agg) {
        this.minuteTime = [];
        this.minuteValue = [];
        this.exportMinute = [];
        this.minuteSum = '';
        this.minuteShow = true;
        getTimeDeviceHistory(this.deviceInfo.entityType, this.deviceInfo.id, this.key, this.startTime, this.endTime, interval, agg).then(response => {
          this.minuteShow = false;
          if(response['rainfall'].length > 0) {
            response['rainfall'].sort(function (a, b) {
              return -(a.ts - b.ts);
            })
          }
          let sum = 0;
          for(let i = 0; i < response['rainfall'].length - 1; i++) {
            let num = 0;
            if(parseFloat(response['rainfall'][i].value) - parseFloat(response['rainfall'][i + 1].value) < 0) {
              num = parseFloat(parseFloat(response['rainfall'][i].value).toFixed(2));
              sum += num;
            } else {
              num = parseFloat((parseFloat(response['rainfall'][i].value) - parseFloat(response['rainfall'][i + 1].value)).toFixed(2));
              sum += num;
            }

            this.minuteTime.push(this.dateFormat(response['rainfall'][i].ts).substring(5));
            this.minuteValue.push(num);
            this.exportMinute.push({
              ts: this.dateFormat(response['rainfall'][i].ts),
              value: num
            })
          }
          this.minuteSum = sum.toFixed(2);
          if(this.minuteTime.length !== 0){
            this.setMinuteOption();
          }

        }).catch(error => {
          this.minuteShow = false;
          this.setMinuteEmpty();
          console.log("error", error);
        })
      },

      /**
       * 初期化一天内数据柱状图
       * @param response
       */
      iniDayHistory() {
        this.dayData();
      },

      /**
       * 获取一月内每一天访问数据库的时间段
       */
      dayData() {
        this.dayShow = true;
        this.setDayEmpty();
        let month = moment().format('MM') == 1 ? 12 : moment().format('MM') - 1;
        let year =  moment().format('MM') == 1 ? moment().format('YYYY') - 1 : moment().format('YYYY');
        let dayLength;
        let arrTime = [];
        if(month == 1 || month == 3 || month == 5 || month == 7 || month == 8 || month == 10 || month == 12){
          dayLength = 31;
        } else if((year % 4 == 0 && year % 100 != 0 || year % 400 == 0) && month == 2){
          dayLength = 29;
        } else if(!(year % 4 == 0 && year % 100 != 0 || year % 400 == 0) && month == 2){
          dayLength = 28;
        } else {
          dayLength = 30;
        }

        for(let i = 0; i < dayLength; i++){
          let startTime = new Date(moment().startOf('day').subtract(i,"days")).getTime();
          let endTime = new Date(moment(startTime).add(5, 'minutes')).getTime();
          arrTime.push(startTime,endTime);
        }
        this.dayName = this.$t("dayRain");
        this.dayHistoryInfo(arrTime,dayLength, 1);
      },

      /**
       * 获取一年内每一个月访问数据库的时间段
       */
      monthData() {
        this.dayShow = true;
        this.setDayEmpty();
        let arrTime = [];
        for(let i = 0; i < 12; i++){
          let startTime = new Date(moment().startOf('month').subtract(i,"months")).getTime();
          let endTime = new Date(moment(startTime).add(5, 'minutes')).getTime();
          arrTime.push(startTime,endTime);
        }
        this.dayName = this.$t("monthRain");
        this.dayHistoryInfo(arrTime,12, 2);
      },

      /**
       * 获取每一天或者每一月的雨量
       */
      dayHistoryInfo(arrTime, dayLength, ban) {
        let interval = 1000 * 60 * 10;
        let totalRain = [];
        for(let i = 0; i < arrTime.length; i+=2) {
          getTimeDeviceHistory(this.deviceInfo.entityType, this.deviceInfo.id, this.key, arrTime[i], arrTime[i + 1], interval, 'MAX').then(response => {
            let dayRain = {};
            if(JSON.stringify(response) === "{}"){
              dayRain.ts = arrTime[i+1];
              dayRain.value = '000';
              totalRain.push(dayRain);
            } else {
              for(let obj in response){
                dayRain.ts = response[obj][0].ts;
                dayRain.value = parseFloat(response[obj][0].value);
                totalRain.push(dayRain);
              }
            }
            // for(let obj in response){
            //   console.log("11111111111", response)
            //   for(let j = 0; j < response[obj].length; j++){
            //     dayRain.ts = response[obj][j].ts;
            //     dayRain.value = parseFloat(response[obj][j].value);
            //     totalRain.push(dayRain);
            //   }
            // }
            if(totalRain.length === dayLength){
              totalRain.sort(function (a,b) {
                return -(a.ts - b.ts);
              })
              for(let j = 0; j < totalRain.length; j++) {
                if(j === 0 && totalRain[j].value === '000'){
                  totalRain[j].value = 0;
                } else if(j !== 0 && totalRain[j].value === '000'){
                  totalRain[j].value = totalRain[j - 1].value;
                }
              }
              this.setDayData(totalRain, ban);
            }
          }).catch(error => {
            console.log("error",error)
          })
        }
      },

      /**
       * 对一月的雨量进项操作，获取每天或者每周增长量
       */
      setDayData(totalRain, ban) {
        this.dayTime = [];
        this.dayValue = [];
        this.exportDay = [];
        this.daySum = '';
        let sum = 0;
        for(let i = 0; i < totalRain.length - 1; i++) {
          let num = 0;
          if((totalRain[i].value - totalRain[i + 1].value) < 0){
            num = parseFloat(parseFloat(totalRain[i].value).toFixed(2));
            sum += num;
          } else {
            num = parseFloat((totalRain[i].value - totalRain[i + 1].value).toFixed(2));
            sum += num;
          }
          this.dayTime.push(this.dateFormat(totalRain[i].ts).substring(5));
          this.dayValue.push(num);
          this.exportDay.push({
            ts: this.dateFormat(totalRain[i].ts),
            value: num
          })
        }
        this.daySum = sum.toFixed(2);
        if(this.dayTime.length !== 0){
          this.setDayOption(ban);
        }
        this.dayShow = false;
      },

      setMinuteEmpty() {
        document.getElementById("minute").removeAttribute("_echarts_instance_");
        let minute = this.$echarts.init(document.getElementById('minute'));
        minute.setOption({});
      },

      setMinuteOption() {
        let minute = this.$echarts.init(
          document.getElementById("minute")
        );
        minute.setOption({
          color: ['#0FFF06',],//#0FFF06
          title: {
            text: this.minuteName,
            left: 'center', //居中
            top:'5%',
            textStyle: {
              color: '#ffffff',
              fontSize: 22,
              lineHeight: 35,
              fontWeight: 'normal'
            }
          },
          tooltip: { //提示框
            trigger: 'axis',
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'line' // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: '2%',
            right: '4%',
            bottom: '0%',
            top:'20%',
            containLabel: true //grid区域是否包含坐标轴的刻度标签
          },
          xAxis: {
            name: this.$t("time"),
            type: 'category', //坐标轴类型。
            nameTextStyle:{
              color:'#fff',
            },
            boundaryGap: true, //坐标轴两边留白策略
            data: this.minuteTime,
            offset: 5,
            axisLabel: {//坐标轴刻度标签的相关设置
              // rotate: 30,
              //interval: 0,
              rotate: -20,
              show: true,
              textStyle: {
                color: '#fff',
                fontSize :10//字体大小
              },
            },
            axisLine:{//坐标轴轴线相关设置
              show :true,
              lineStyle:{
                // color:'#3a4650'// rgb(2,121,253)
                color: 'rgba(231, 244, 255, 0.2)'
              }
            },
            axisTick:{ //坐标轴刻度相关设置。
              show :false,
            }
          },
          yAxis: {
            name: this.$t("value") + '(mm)',
            type: 'value',
            nameTextStyle:{
              color:'#fff',
            },
            show: true, //隐藏坐标
            axisLabel: { //y轴的坐标文字
              show: true, //不显示坐标控件
              textStyle: {
                color: '#fff' //文字的颜色
              },

            },
            // max:this.max,//最大值
            // min:this.min,
            splitLine:{  //坐标在grid区域的分割线
              show: false,// 不显示网格
              lineStyle: { //设置分割线的样式(图表横线颜色)
                color: ['#153a8a'] //网格颜色
              }
            },
            axisLine:{//坐标轴轴线相关设置
              show :true,
              lineStyle:{
                color:'rgba(231, 244, 255, 0.2)'//#3a4650  rgb(2,121,253) #3a4650
              }
            },
            axisTick:{ //坐标轴刻度相关设置。
              show :false,
            },
          },
          series: [
            {
              type: 'line',
              data:  this.minuteValue,
              symbolSize: 10,
              smooth: true,
              animationDuration: 1000,
              lineStyle:{
                // color:'#1CFF0E'  //线的颜色
                color:'#0FFF06'
              },
              tooltip: { //提示框
                trigger: 'axis',
                axisPointer: { // 坐标轴指示器，坐标轴触发有效
                  type: 'line' // 默认为直线，可选为：'line' | 'shadow'
                },
              },
            },
            {
              type: 'bar',
              data: this.minuteValue,
              itemStyle:{
                color:'#67e0e3',
                normal: {
                  label: {
                    show: true, //开启显示数值
                    position: 'top', //数值在上方显示
                    textStyle: {  //数值样式
                      color: '#ffffff',   //字体颜色
                      fontSize: 10  //字体大小
                    }
                  },
                  color:'#67e0e3'
                }
              },
              tooltip: {
                trigger: "axis",
                show: false,
              }
            },
          ],
          dataZoom: [
            {
              endValue: 25, //一次显示10个
              type: 'slider',//有滑动条
              show: false,//是否显示滑动条
              xAxisIndex: [0],//开始下标
              handleSize: 0,//滑动条的左右2个滑动条大小
              height: 20, //滑动条高度
              left: "0%",//左边距离
              right: "0%",//右边距离
              bottom: 0,//底部距离
              // borderColor: "#3a4650", //边框颜色
              borderColor: "#101f3e", //边框颜色
              fillerColor: "#4C7C98",//选中区域的背景色#345A7C#4878fe
              borderRadius: 5,//边框弧度
              //backgroundColor: "#1c2735",//未选区域中的背景色
              backgroundColor:'#0b2d4c',
              showDataShadow: false, //是否显示数据阴影
              showDetail:false,//拖动时是否显示数值
              realtime: true,// 是否实时更新
              filterMode: "filter",
            },
            {
              //左右滑动
              type: "inside",
              show: true,
              xAxisIndex: [0],
              start: 0,
              end: 100,
            }
          ]
        });
      },

      setDayEmpty() {
        document.getElementById("day").removeAttribute("_echarts_instance_");
        let minute = this.$echarts.init(document.getElementById('day'));
        minute.setOption({});
      },

      setDayOption(ban) {
        let day = this.$echarts.init(
          document.getElementById('day')
        );
        day.setOption({
          color: ['#0FFF06',],//#0FFF06
          title: {
            text: this.dayName,
            left: 'center', //居中
            textStyle: {
              color: '#ffffff',
              fontSize: 22,
              lineHeight: 35,
              fontWeight: 'normal'
            }
          },
          tooltip: { //提示框
            trigger: 'axis',
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'line' // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: '2%',
            right: '4%',
            bottom: '0%',
            top:'20%',
            containLabel: true //grid区域是否包含坐标轴的刻度标签
          },
          xAxis: {
            name: this.$t("time"),
            type: 'category', //坐标轴类型。
            nameTextStyle:{
              color:'#fff',
            },
            boundaryGap: true, //坐标轴两边留白策略
            data: this.dayTime,
            offset: 3,
            axisLabel: {//坐标轴刻度标签的相关设置
              // rotate: 30,
              interval: 0,
              rotate: -20,
              show: true,
              textStyle: {
                color: '#fff',
                fontSize :10//字体大小
              },
            },
            axisLine:{//坐标轴轴线相关设置
              show :true,
              lineStyle:{
                // color:'#3a4650'// rgb(2,121,253)
                color: 'rgba(231, 244, 255, 0.2)'
              }
            },
            axisTick:{ //坐标轴刻度相关设置。
              show :false,
            }
          },
          yAxis: {
            name:  this.$t("value") + '(mm)',
            type: 'value',
            nameTextStyle:{
              color:'#fff',
            },
            show: true, //隐藏坐标
            axisLabel: { //y轴的坐标文字
              show: true, //不显示坐标控件
              textStyle: {
                color: '#fff' //文字的颜色
              },

            },
            // max:this.max,//最大值
            // min:this.min,
            splitLine:{  //坐标在grid区域的分割线
              show: false,// 不显示网格
              lineStyle: { //设置分割线的样式(图表横线颜色)
                color: ['#153a8a'] //网格颜色
              }
            },
            axisLine:{//坐标轴轴线相关设置
              show :true,
              lineStyle:{
                color:'rgba(231, 244, 255, 0.2)'//#3a4650  rgb(2,121,253) #3a4650
              }
            },
            axisTick:{ //坐标轴刻度相关设置。
              show :false,
            },
          },
          series: [
            {
              type: 'line',
              data: this.dayValue,
              symbolSize: 10,
              smooth: true,
              animationDuration: 1000,
              lineStyle:{
                // color:'#1CFF0E'  //线的颜色
                color:'#0FFF06'
              },
              tooltip: { //提示框
                trigger: 'axis',
                axisPointer: { // 坐标轴指示器，坐标轴触发有效
                  type: 'line' // 默认为直线，可选为：'line' | 'shadow'
                },
              },
            },
            {
              type: 'bar',
              data: this.dayValue,
              itemStyle:{
                color:'#67e0e3',
                normal: {
                  label: {
                    show: true, //开启显示数值
                    position: 'top', //数值在上方显示
                    textStyle: {  //数值样式
                      color: '#ffffff',   //字体颜色
                      fontSize: 10  //字体大小
                    }
                  },
                 /* color: arg => {
                    if(arg.value > 50) {
                      return 'red'
                    } else if(arg.value > 25) {
                      return 'orange'
                    } else if(arg.value > 10) {
                      return 'yellow'
                    } else if(arg.value > 0){
                      return 'blue'
                    } else {
                      return '#67e0e3'
                    }
                  }*/
                  color: function (arg) {
                    if(ban ===1) {
                      if(arg.value >= 50) {
                        return 'red'
                      } else if(arg.value >= 25) {
                        return 'orange'
                      } else if(arg.value >= 10) {
                        return 'yellow'
                      } else if(arg.value > 0){
                        return 'blue'
                      } else {
                        return '#67e0e3'
                      }
                    } else {
                      return '#67e0e3'
                    }
                  }
                }
              },
              tooltip: {
                trigger: "axis",
                show: false,
              }
            },
          ],
        });
      },

      /**
       * 分钟打印
       */
      minuteExport(){
        this.export(this.exportMinute, this.minuteName);
      },

      /**
       * 日打印
       * @constructor
       */
      DayExport(){
        this.export(this.exportDay, this.dayName);
      },

      /**
       * 打印
       * @param exportList
       * @param name
       */
      export(exportList, name) {
        let that = this;
        if (exportList.length === 0) {
          // alert("该时间区间内没有数据，请重新选择");
          that.$message({
            showClose: true,
            type: "warning",
            message: this.$t("noData")
          });
          return;
        }
        const {export_json_to_excel} = require('../vendor/Export2Excel');
        const tHeader = [this.$t("time"), this.$t("value"),];
        const filterVal = ['ts', 'value',];
        const list = exportList;
        const data = that.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, name + " " +  this.$t("dataList"));
      },

      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]));
      },

      dateFormat(timestamp) {
        if(timestamp && timestamp !== ''){
          let dateStr = moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
          return dateStr;
        }
        return "-";
      },
    }
  }
</script>
<style lang="less">
  @import "less/StatisticalData";
</style>




// WEBPACK FOOTER //
// src/components/StatisticalData.vue